module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//pet-info_block.png?v=d2e07207";